export default __webpack_public_path__ + "static/media/dean_phillips.df0a77ef.png";